import { useCallback, useEffect } from 'react';
import { useMediaQuery } from '@mui/material';
import { BeforeInstallPromptEvent } from 'models';
import { getUserDevice } from 'utils';
import { useStore } from 'providers';
import { pushAnalyticsEvent, InstallationEvent } from 'helpers/analytics';

const { addEventListener, removeEventListener, matchMedia } = window;

export const useAddToHomeScreen = () => {
  const { store, dispatch } = useStore();
  const { installationPrompt: promptEvent } = store;

  useEffect(() => {
    const handlePromptEvent = (installationPrompt: BeforeInstallPromptEvent) => {
      installationPrompt.preventDefault();

      dispatch({
        type: 'setInstallationPrompt',
        payload: { installationPrompt },
      });
    };

    addEventListener('beforeinstallprompt', handlePromptEvent);

    return () => {
      removeEventListener('beforeinstallprompt', handlePromptEvent);
    };
  }, [dispatch]);

  const promptType = getUserDevice();
  const isDesktop = useMediaQuery('(pointer:fine)') || !promptType;
  const isRunningAsApp = navigator.standalone || matchMedia('(display-mode: standalone)').matches;
  const showPrompt = !isRunningAsApp && !isDesktop;
  const canPrompt = !isRunningAsApp && promptType === 'Android';

  const addToHomeScreen = useCallback(
    (promptLocation: InstallationEvent['location']) => {
      pushAnalyticsEvent({
        event: 'addToHomeScreen',
        operationSystem: promptType,
        location: promptLocation,
      });

      if (promptEvent) {
        return promptEvent.prompt();
      }

      return Promise.resolve();
    },
    [promptEvent, promptType]
  );

  return { showPrompt, canPrompt, addToHomeScreen };
};
